exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".kong.content{text-align:center;width:100%}.燒燙燙{min-height:150px}.燒燙燙 .loading{display:none}.燒燙燙 a{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/Iah/Kong/Kong.css
// module id = 664
// module chunks = 0